import React, { useEffect, useState } from "react";
import { Button, Dropdown, Menu, message } from "@cloud/atom-ui";
import "./style.m.less";
import logoIcon from './assets/logo.svg';
import pullDownIcon from './assets/pullDown.svg';
import HorizontalMenu from '../HorizontalMenu';
import { pclogout } from './thunk';
import i18n from '@src/i18n';
import webConfig from '../../configs/web.config';
import { getUserInfo, goToDocs } from "../../utils/common";

const HomeHeader = () => {
  const [isLogin, setIsLogin] = useState();
  const [userInfo, setUserInfo] = useState({});

  const menu = (
    <Menu onClick={e => handleMenuClick(e)}>
      <Menu.Item key="logout">
        {i18n.t('home:logOut')}
      </Menu.Item>
    </Menu>
  );

  const handleMenuClick = e => {
    if (e.key === 'logout') {
      onLogout();
    }
  };

  // 登录
  const onLogin = () => {
    location.href = webConfig.goLoginURl(window.location.href);
  };

  // 登出
  const onLogout = () => {
    pclogout().then((res) => {
      if (res) {
        setIsLogin(!isLogin);
        let redirectUrl = `https://login-beta.huawei.com/login/logout.do?redirect=${window.location.href}`
        if (window.location.origin === 'https://open.inner.welink.huawei.com') {
          redirectUrl = `https://login.huawei.com/login/logout.do?redirect=${window.location.href}`
        }
        location.href = redirectUrl
      } else {
        message.error(i18n.t('home:logOutFailed'));
      }
    });
  };

  // 获取登录人员信息
  const getCurrentUserInfo = () => {
    getUserInfo().then(res => {
      setUserInfo(res?.currUser || {});
      localStorage.setItem('userAccount', res?.currUser.account)
      setIsLogin(res?.currUser?.account ? true : false);
    });
  };

  const menuList = [
    { key: 'document', label: i18n.t('home:devDocument'), operation: goToDocs },
  ];

  useEffect(() => {
    getCurrentUserInfo();
  }, []);

  return (
    <div className="headerContent">
      <div className="left">
        <img className="logo" src={logoIcon} />
        <div style={{ marginLeft: 40 }}>
          <HorizontalMenu menus={menuList} />
        </div>
      </div>
      {isLogin ? (
        <div className="right">
          {Object.keys(userInfo)?.length ? (
            <Dropdown overlay={menu}>
              <span className="userInfo">
                {userInfo?.name}
                <img className="pullDown" src={pullDownIcon} />
              </span>
            </Dropdown>
          ) : (
            <Button className="login" type="primary" onClick={onLogin}>{i18n.t('home:login')}</Button>
          )}
        </div>
      ) : null}
    </div>
  )
};

export default HomeHeader;
